import React from 'react';
import ContentLoader from 'react-content-loader';

const LogsLoader = () => (
  <ContentLoader
    height={52}
    width={360}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    viewBox={`0 0 360 52`}
  >
    <rect x="16" y="0" rx="16" ry="16" width="16" height="16" />
    <rect x="40" y="2" rx="0" ry="0" width="280" height="12" />
    <rect x="16" y="25" rx="0" ry="0" width="220" height="12" />
  </ContentLoader>
);

export default LogsLoader;
